import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {Grid, makeStyles} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import { formatAmount } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr:{
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth:'46%',
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth:'100%',
    },
    "@media (max-width: 450px)": {
      margin:"10% 2% 0px 2%"
    },
  },
}));

const DisbursalDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [maritalStatus, setMaritalStatus] = useState("");
  const [data, setData] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);
  const [maturityDate, setMaturityDate] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [transferToBank, setTransferTobank] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId,"flaljdfkjadjk")
  useEffect(() => {
    if (leadId) {
      fetchLoanSummary();
    }
  }, [leadId]);

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_LEAD_DETAILS_FIND_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setMaritalStatus(result?.data?.loanAccountNumber);
      setMaturityDate(result?.data?.maturityDate);
      getRepaymentDetails();
    }
  };
  const getRepaymentDetails = async () => {
    setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.GET_LOAN_REPAYMENT_DETAILS_API + leadId,
          method:"POST",
          authToken: authToken,
        });
        setCallInProgress(false);
        console.log(result?.data, "API DATA");
        setData(result?.data)
        loanPaymentDetails(result?.data?.schemeCode,result?.data?.loanAmount)
  }
  const loanPaymentDetails = async (schemeCode, amount) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.GET_LOAN_PAYMENT_DETAILS_API +
        leadId +
        "/" +
        schemeCode +
        `?loanAmount=${amount}`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.netDisbursalAmount) {
      setTransferTobank(result?.data?.netDisbursalAmount);
    } else {
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };
  const handleNext = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DISBURSAL_TO_LMS_API + leadId + `?newDisbursement=true`,
      method:"POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    }else{
      navigate('/journey/DisbursalInfo');
    }

  }
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader label="Disbursal Details"/>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Loan Account Number"
              placeholder="Loan Account Number"
              value={maritalStatus}
              style={classes.inputField}
              disabled={true}
              />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Loan Amount (₹)"
              placeholder="Loan Amount (₹)"
              value={formatAmount(String(data?.loanAmount))}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Interest Amount (₹)"
              placeholder="Interest Amount (₹)"
              value={formatAmount(String(data?.interestAmount))}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Net Disbursed Amount (₹)"
              placeholder="Net Disbursed Amount (₹)"
              value={formatAmount(String(transferToBank))}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Maturity Date"
              placeholder="Maturity Date"
              value={parseDateMDY(maturityDate)}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label={`Tenure (${data?.tenureType?.toLowerCase()})`}
              placeholder="Tenure"
              value={String(data?.tenure)}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Installment (₹)"
              placeholder="Installment"
              value={formatAmount(String(data?.installmentAmount))}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Next Installment"
              placeholder="Next Installment"
              value={parseDateMDY(String(data?.installments?.[0]?.installmentDueDate))}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Rate of Interest (Per Day %)"
              placeholder="Rate of Interest (%)"
              value={(Number(data?.interestRate || 0) / 360).toFixed(2)}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <BottomButton button1={"Next"} button1click={handleNext}/>
      </Grid>
      {toast && (
              <ToastModal
                toastMessage={toastMessage}
                toastMessageType={toastMessageType}
                toastUpdate={toastUpdate}
              />
            )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default DisbursalDetails;